// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3ZMFK","rootSmall":"AddTileButton_rootSmall__KVFlz"};